import ActivityStore from './activityStore';
import BlanketStore from './blanketStore';
import DrawerStore from './drawerStore';
import FeatureFlagsStore from './featureFlagsStore';
import FlagStore from './flagStore';
import NotificationsStore from './notificationsStore';
import ProductStore from './productStore';
import SearchStore from './searchStore';
import UIStore from './uiStore';
import UserStore from './userStore';

export default interface Store {
  activityStore: ActivityStore;
  blanketStore: BlanketStore;
  drawerStore: DrawerStore;
  featureFlagsStore: FeatureFlagsStore;
  flagStore: FlagStore;
  notificationsStore: NotificationsStore;
  productStore: ProductStore;
  searchStore: SearchStore;
  uiStore: UIStore;
  userStore: UserStore;
}

export const createStore = (): Store => {
  return {
    activityStore: new ActivityStore(),
    blanketStore: new BlanketStore(),
    drawerStore: new DrawerStore(),
    featureFlagsStore: new FeatureFlagsStore(),
    flagStore: new FlagStore(),
    notificationsStore: new NotificationsStore(),
    productStore: new ProductStore(),
    searchStore: new SearchStore(),
    uiStore: new UIStore(),
    userStore: new UserStore(),
  };
};
